import { render } from "./AndroidProducts.vue?vue&type=template&id=055f0cd0"
import script from "./AndroidProducts.vue?vue&type=script&setup=true&lang=js"
export * from "./AndroidProducts.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/products/android/AndroidProducts.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "055f0cd0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('055f0cd0', __exports__)) {
    console.log('reload')
    api.reload('055f0cd0', __exports__)
  }
  
  module.hot.accept("./AndroidProducts.vue?vue&type=template&id=055f0cd0", () => {
    console.log('re-render')
    api.rerender('055f0cd0', render)
  })

}


export default __exports__